import { render, staticRenderFns } from "./MixAggregateList.vue?vue&type=template&id=a1ac506c"
import script from "./MixAggregateList.vue?vue&type=script&lang=js"
export * from "./MixAggregateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports